/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  GCPPubSubConfig,
  GCPPubSubConfig$inboundSchema,
  GCPPubSubConfig$Outbound,
  GCPPubSubConfig$outboundSchema,
} from "./gcppubsubconfig.js";
import {
  GCPPubSubCredentials,
  GCPPubSubCredentials$inboundSchema,
  GCPPubSubCredentials$Outbound,
  GCPPubSubCredentials$outboundSchema,
} from "./gcppubsubcredentials.js";
import {
  Topics,
  Topics$inboundSchema,
  Topics$Outbound,
  Topics$outboundSchema,
} from "./topics.js";

export type DestinationUpdateGCPPubSub = {
  /**
   * "*" or an array of enabled topics.
   */
  topics?: Topics | undefined;
  /**
   * Optional JSON schema filter for event matching. Events must match this filter to be delivered to this destination.
   *
   * @remarks
   * Supports operators: $eq, $neq, $gt, $gte, $lt, $lte, $in, $nin, $startsWith, $endsWith, $exist, $or, $and, $not.
   * If null or empty, all events matching the topic filter will be delivered.
   * To remove an existing filter when updating a destination, set filter to an empty object `{}`.
   */
  filter?: { [k: string]: any } | null | undefined;
  config?: GCPPubSubConfig | undefined;
  credentials?: GCPPubSubCredentials | undefined;
  /**
   * Static key-value pairs merged into event metadata on every attempt.
   */
  deliveryMetadata?: { [k: string]: string } | null | undefined;
  /**
   * Arbitrary contextual information stored with the destination.
   */
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationUpdateGCPPubSub$inboundSchema: z.ZodType<
  DestinationUpdateGCPPubSub,
  z.ZodTypeDef,
  unknown
> = z.object({
  topics: Topics$inboundSchema.optional(),
  filter: z.nullable(z.record(z.any())).optional(),
  config: GCPPubSubConfig$inboundSchema.optional(),
  credentials: GCPPubSubCredentials$inboundSchema.optional(),
  delivery_metadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    "delivery_metadata": "deliveryMetadata",
  });
});
/** @internal */
export type DestinationUpdateGCPPubSub$Outbound = {
  topics?: Topics$Outbound | undefined;
  filter?: { [k: string]: any } | null | undefined;
  config?: GCPPubSubConfig$Outbound | undefined;
  credentials?: GCPPubSubCredentials$Outbound | undefined;
  delivery_metadata?: { [k: string]: string } | null | undefined;
  metadata?: { [k: string]: string } | null | undefined;
};

/** @internal */
export const DestinationUpdateGCPPubSub$outboundSchema: z.ZodType<
  DestinationUpdateGCPPubSub$Outbound,
  z.ZodTypeDef,
  DestinationUpdateGCPPubSub
> = z.object({
  topics: Topics$outboundSchema.optional(),
  filter: z.nullable(z.record(z.any())).optional(),
  config: GCPPubSubConfig$outboundSchema.optional(),
  credentials: GCPPubSubCredentials$outboundSchema.optional(),
  deliveryMetadata: z.nullable(z.record(z.string())).optional(),
  metadata: z.nullable(z.record(z.string())).optional(),
}).transform((v) => {
  return remap$(v, {
    deliveryMetadata: "delivery_metadata",
  });
});

export function destinationUpdateGCPPubSubToJSON(
  destinationUpdateGCPPubSub: DestinationUpdateGCPPubSub,
): string {
  return JSON.stringify(
    DestinationUpdateGCPPubSub$outboundSchema.parse(destinationUpdateGCPPubSub),
  );
}
export function destinationUpdateGCPPubSubFromJSON(
  jsonString: string,
): SafeParseResult<DestinationUpdateGCPPubSub, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DestinationUpdateGCPPubSub$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DestinationUpdateGCPPubSub' from JSON`,
  );
}
